

import { Component, OnInit } from '@angular/core';
import { NotificationAlert } from '../../models/notificationAlert.model';
import { ToasterNotificationService } from './toaster-notification.service';

@Component({
  selector: 'app-toaster-notification',
  templateUrl: './toaster-notification.component.html',
  styleUrls: ['./toaster-notification.component.scss', '../alert/alert.component.scss'],
})
export class ToasterNotificationComponent implements OnInit {
  alerts: NotificationAlert[] = [];
  constructor(private toasterNotificationService: ToasterNotificationService) {
    this.toasterNotificationService.notification.subscribe((alert: NotificationAlert) => {
      this.alerts.push(alert);
      this.removeAlert(alert);
    });
  }


  ngOnInit(): void {
  }

  private removeAlert(alert: NotificationAlert) {
    setTimeout(() => {
      this.close(alert);
    }, 5000);
  }

  public close(alert: NotificationAlert): void {
    this.alerts.splice(this.alerts.indexOf(alert), 1);
  }

}
